import { Button, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const DeleteConfirmation = ({ title, show = false, handleSubmit, handleCancel }) => {
  const { t } = useTranslation(["translation"]);

  return (
    <div id="deleteUserModal">
      <Modal show={show} onHide={handleCancel}>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{t("userList.deleteModal.text_1")}</p>
          <p className="text-danger">
            <small>{t("userList.deleteModal.text_2")}</small>
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCancel}>
            {t("userList.cancel")}
          </Button>
          <Button variant="danger" onClick={handleSubmit}>
            {t("userList.delete")}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default DeleteConfirmation;
